import styled from 'styled-components';

export const ReceiptUrl = styled.a`
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  text-decoration-line: none;
  border-bottom: 1px solid #858dbd;
  display: inline-flex;
  color: var(--color-text-muted);

  :hover {
    border-bottom: 1px solid transparent;
  }
`;
